export const ADMIN_REVIEWS_LIST_KEY = 'REVIEWS_LIST';
export const ADMIN_REVIEWS_ONE_KEY = 'ADMIN_REVIEWS_ONE_KEY';

export const REVIEW_REPORT_CAUSES_LIST_KEY = 'REVIEW_REPORT_CAUSES_LIST_KEY';

export const REVIEW_ANALYTIC_SUMMARY = 'REVIEW_ANALYTIC_SUMMARY';
